import * as ImageManipulator from "expo-image-manipulator";

import { UserImageMedia, UserLikableImageMedia } from "@/schemas/user/image";

interface ImageResult {
  uri: string;
  width: number;
  height: number;
}

async function processAvatarImage(
  imageUri: string,
  size = 300,
): Promise<ImageResult> {
  // Step 1: Resize the image to a square
  const resizedImage = await ImageManipulator.manipulateAsync(
    imageUri,
    [{ resize: { width: size, height: size } }],
    { format: ImageManipulator.SaveFormat.PNG },
  );

  // Step 2: Crop the image to a circle
  const circularImage = await ImageManipulator.manipulateAsync(
    resizedImage.uri,
    [
      {
        crop: {
          originX: 0,
          originY: 0,
          width: size,
          height: size,
        },
      },
    ],
    { format: ImageManipulator.SaveFormat.PNG },
  );

  // Step 3: Compress the image
  const compressedImage = await ImageManipulator.manipulateAsync(
    circularImage.uri,
    [],
    {
      compress: 0.8,
      format: ImageManipulator.SaveFormat.PNG,
    },
  );

  return compressedImage;
}

export default processAvatarImage;

export function calculateImageHash(): string {
  // This has been deprecated in favor of calculating the hash on the server side.
  return "";
}

export const transformUserImagesToUserLikableImages = (
  items: UserImageMedia[],
): UserLikableImageMedia[] => {
  return items.map((image) => ({
    isLiked: false, // default to not liked for user's own new uploads
    image,
  }));
};
